export default [
  {
    id: 1,
    possibleMistakeCount: 10,
    title: 'Что произойдёт с вами, если вы будете делать планку каждый день',
    text: "1. Мышцы кора станут сильнее //n Мышцы кора обеспечивают поддержку внутрених//внутренних органов. " +
    "Они так&nbsp;же//также учавствуют//участвуют в формировании хорошей осанки и помогают избежать травм " +
    "нижней части спины. Ежедневное выполнение планки прежде всего поможет вам укрепить эти мышцы. //n " +
    "2. Ускориться//ускорится обмен веществ //n Планка сжигает больше каллорий,//калорий, чем " +
    "классические упражнения для пресса — скручивания и подьёмы//подъёмы туловища. Даже 10 минут" +
    " силовых упражнений в день ускоряют обмен веществ. При&nbsp;чём//причём на достаточно" +
    " продолжительное время: даже ночью вы будете сжигать больше калорий. Приятный бонус для тех," +
    " кто хочет похудеть. //n 3. Улучшится психологическое состояние //n Планка по-особенному " +
    "воздействует на нервы, укрепляя мышцы, активные в стресовых//стрессовых ситуациях. " +
    "После целого дня в рабочем кресле всё ваше тело затекает, вы чуствуете//чувствуете напряжение. " +
    "Как следствие, настроение ухудшаеться,//ухудшается, вы становитесь вялым и унылым." +
    " Ежедневное выполнение планки поможет улучшить настроение и окажет положительное воздействие" +
    " на нервную систему. Всего 5–10 минут дадут вам заряд энергии на весь день, а ежедневное повторение " +
    " — на всю жизнь."
  },
  {
    id: 2,
    possibleMistakeCount: 9,
    title: '25 жизненных уроков, которые нужно усвоить, пока не стало слишком поздно',
    text: "1. Верьте в себя //n Часто нас ограничивает только отсутсвие//отсутствие веры в себя. " +
    "Всё вокруг нас было созданно//создано такими же людьми, как и мы сами. " +
    "Так что верьте в себя, мечтайте, творите и меняйте мир. //n 2. Не работайте сверхурочно //n " +
    "Цените своё свободное время и не засиживайтесь на работе до&nbsp;поздна.//допоздна. Это не поможет " +
    "завоевать расположение коллег, а вы только будете сожалеть, что кроме" +
    " работы ничего не успеваете. //n 3. Постоянно совершенствуйтесь //n Каждый день старайтесь " +
    "совершенствоваться в какой&nbsp;то//какой-то области. Не обязательно меняться" +
    " координально,//кардинально, достаточно день изо дня становится//становиться лучше хотя бы" +
    " на 1%. Так со временем вы достигните//достигнете значительных результатов." +
    " Главное, не ждите, что всё сложиться//сложится само собой. Чтобы стать лучше," +
    " нужно прилагать усилия. Ни&nbsp;кто//никто ещё не добился успеха," +
    " сидя сложа руки. //n 4. Практикуйтесь //n Считается, что нужно 10 000 часов" +
    " практики, чтобы достич//достичь мастерства в какой-то области. Но ещё лучше" +
    " потратьте 1 000 часов на 10 разных предметов: так у вас будут знания сразу в " +
    "нескольких областях. А это откроет дорогу к новым возможностям."
  },
  {
    id: 3,
    possibleMistakeCount: 8,
    title: '20 вещей, которые необходимо сделать в 30 лет, чтобы в 50 было хорошо',
    text: "1. Перестать есть всякое дерьмо //n В ранем//раннем возрасте наши вкусы " +
    "во многом определяются семьёй, в которой мы растём. Но в 30 лет пора уже включить" +
    " мозги и понять, что правильное питание имеет прямую связь с вашим самочувствием и" +
    " долголетием. Самое время перестать перекусывать на ходу, обьедаться//объедаться пиццей " +
    "и хотдогами,//хот-догами, пить литрами колу и пиво. //n 2. Начать сохранять деньги. Даже по " +
    "немногу//понемногу //n Экономьте деньги. Да, этот совет выглядит скучным, " +
    "банальным и не сексуальным,//несексуальным, но это действительно нужно." +
    " Сейчас вы находитесь на пике своей формы, которая в дальнейшем пойдёт на спад," +
    " так что наступит день, когда сделаные//сделанные сбережения " +
    "вам пригодяться.//пригодятся. //n 3. Начать колекционировать//коллекционировать впечатления, " +
    "а не деньги //n Вы — это сумма ваших периживаний.//переживаний. " +
    "Однажды вы проснётесь и поймёте, что все ваши пожитки не имеют" +
    " ни какого//никакого значения и ценности. Только ваши воспоминания и " +
    "впечатления не теряют в цене со временем и всегда остаются с вами."
  },
  {
    id: 4,
    possibleMistakeCount: 7,
    title: 'Как почистить телефон от мусора, удалить вирусы и ускорить его работу',
    text: "1. Как почистить Android&nbsp;смартфон//Android-смартфон системными инструментами //n Если " +
    "вы не хотите использовать никакие сторонние програмы,//программы, то в свежих " +
    "версиях Android имееться//имеется встроенная функция очистки мусора. " +
    "Дополнительная ценность метода — в его безопасности: таким образом вы точно" +
    " не удалите что-нибудь нужное. Для очистки Android штатными средствами необходимо " +
    "открыть настройки системы и найти раздел «Хранилище». Выберите внутренюю//внутреннюю память " +
    "устройства, и вы увидите список имеющегося на смартфоне контента. Сделайте тап по пункту" +
    " «Данные кэша»//кеша» и согласитесь с их удалением в//во всплывающем окне." +
    " В результате вы освободитесь от утяжеляющего систему хлама. Ваш телефон будет" +
    " работать на много//намного быстрее. //n 2. Как почистить телефон с помощью утилиты SD Maid //n В" +
    " каталоге Google Play можно найти много разных чистилщиков.//чистильщиков." +
    " По поводу полезности каждого из них ведутся жаркие споры. И только эффективность" +
    " SD Maid не вызывает никаких сомнений. Пользоваться утилитой очень просто." +
    " После запуска нажмите на одну большую зелёную кнопку «Сканировать» и подождите, " +
    "пока SD Maid будет искать мусор в системе. Программа эффективно находит устаревшие логи," +
    " отчёты о//об ошибках, файлы отладки, временные файлы, остатки уже удалёных//удалённых программ" +
    " и всё, что уже не нужно для работы Android. Для уборки мусора необходимо просто " +
    "нажать на кнопку «Запустить сейчас»."
  },
  {
    id: 5,
    possibleMistakeCount: 6,
    title: '12 способов изменить жизнь для тех, у кого совершенно нет сил',
    text: "1. Начните двигаться и не останавливайтесь //n Движение — это не " +
    "только мощное средство для улучшения настроения и уменьшения стресса, но" +
    " и доказано//доказанно эффективный способ сохранения отличной памяти и" +
    " вообще мыслительных навыков. //n 2. Доверяйте интуиции //n Сомнительной красоты" +
    " выражение «нутром чую» вовсе не метафора. Перед принятием важных решений " +
    "преслушивайтесь//прислушивайтесь к своим ощущениям: тело часто подсказывает," +
    " что нам нужно, ещё до того, как мы это осознаем. Возьмите перерыв, если устали. " +
    "Сьездите//съездите куда-нибудь, если душа просит перемен. Словом, когда что-то идёт" +
    " не так, первым делом спросите о причинах себя. Если вы не человек-интуиция, " +
    "потребуется некоторое время, чтобы научится//научиться прислушиваться к внутреннему " +
    "голосу. Просто отвлекитесь от всех забот, передохните и честно ответьте," +
    " что сейчас чуствуете.//чувствуете. Велика вероятность, что вы прекрасно знаете," +
    " чего хотите на самом деле. Нужно лишь на время остановиться и послушать себя. //n 3. " +
    "Питайте душу, а не эго //n Тут всё просто: делайте то, что вас радует. " +
    "Не все наши достижения наполняют душу радостью. Регулярные переработки могут " +
    "быть полезны, но в конечном итоге это приводит к истощению далеко" +
    " небесконечных//не&nbsp;бесконечных резервов организма. Пользы от такого поведения меньше, " +
    "чем от регулярного отдыха и раслабления.//расслабления. Купите, наконец," +
    " туфли, которые давно хотите, побалуйте себя мороженным//мороженым в обеденный " +
    "перерыв и выходные на пролёт//напролёт смотрите старые фильмы. У всех — ну ладно, " +
    "большинства — ваших действий должна быть одна единственная//одна-единственная причина:" +
    " это приносит радость. Вы делаете это не потому, что это очередной пункт в" +
    " списке дел. Радость. Вам. Точка."
  },
  {
    id: 6,
    possibleMistakeCount: 5,
    title: 'Почему каждый мужчина должен тягать железо',
    text: "1. Это полезно для здоровья //n Исследования, проведённые в Университете Мичигана," +
    " очень доходчиво показали одну простую вещь. Три базовых//базовые тренировки в неделю" +
    " на протяжение//протяжении двух месяцев — и твоё АД снижается на восемь пунктов." +
    " В возрасте это означает минус 40% к вероятности инсульта. //n 2. Это укрепляет кости //n С возрастом " +
    "кости мужчины теряют массу, а соответственно, и прочность. В один прекрасный момент это " +
    "может привести к перелому бедра или порвеждению//повреждению позвоночника." +
    " Статистика клиники Майо показывает тревожные данные: 30% мужчин в возрасте умирали" +
    " в течении//течение года после перелома бедра. Ослабление позвоночника делает" +
    " нас похожими на Квазимоду//Квазимодо XXI века. Исследования, опубликованные в" +
    " Journal of Applied Physiology, говорят о повышении прочности бедренной кости" +
    " на 3,8% после 16 недель силовых тренировок. За это же время на 19% увеличивается" +
    " содержание в крови остеокальцина — маркера, говорящего о росте косной//костной ткани." +
    " //n 3. Это не даёт толстеть //n Каждый килограмм потерянных мышц заменяется" +
    " килограммом жыра.//жира. При отсутствии силовых тренировок ваш вес не " +
    "измениться,//изменится, а объёмы и дряблость кожи возрастёт//возрастут " +
    "значительно, так как жировая ткань на 18% обьёмнее//объёмнее мышечной."
  },
  {
    id: 7,
    possibleMistakeCount: 4,
    title: '10 признаков того, что вы встречаетесь с психопатом',
    text: "1. Он обвиняет вас в эмоциях, которые сам и провоцирует //n Психопат скажет, что вы " +
    "слишком ревнивы, хотя откровено//откровенно флиртовал с бывшей, часто даже в " +
    "соц сетях,//соцсетях, чтобы это видели все. Он скажет, что вы слишком прилипчивы," +
    " хотя намеренно игнорировал вас несколько дней. Он провоцирует вашу реакцию, " +
    "чтобы показать другим своим мишеням, как вы истеричны, и вызвать сочуствие//сочувствие к себе." +
    " Вам казалось, что вы спокойный человек? Встреча с психопатом изменит вас до " +
    "неузнаваемости. К счастью, временно. //n 2. Он провоцирует ревность и соперничество, сохраняя маску невиновности //n Сначала " +
    "всё внимание психопата сосредоточенно//сосредоточено на вас. " +
    "И вы не понимаете, что происходит, когда он вдруг переключается на" +
    " другого человека. Он постоянно делает вещи, которые заставляют вас" +
    " сомневатся,//сомневаться, что вы что-то для него значите. Если он активен в" +
    " соцсетях, то приманивает бывших песнями, фотографиями, шутками, которые были значимы " +
    "для их пары. Он будто в активном поиске партнёра и при этом игнорирует " +
    "вас. //n 3. Вы не узнаёте себя //n Ваша любовь и сострадание" +
    " превратилось//превратились в подавляющую панику и беспокойство. Вы " +
    "извиняетесь и плачите//плачете больше, чем когда-либо в своей жизни." +
    " Вы плохо спите и просыпаетесь в плохом и тревожном настроении. Вы не" +
    " можете понять, что случилось с вами, где теперь эта весёлая, " +
    "непринуждёная,//непринуждённая, спокойная личность? После общения с " +
    "психопатом вы чувствуете, что истощены, опустошены и лишены адекватного" +
    " восприятия мира. Жизнь катиться//катится кувырком: вы тратите деньги," +
    " разрываете связи с друзьями и близкими и постоянно ищите//ищете причину этих действий."
  },
  {
    id: 8,
    possibleMistakeCount: 3,
    title: '6 вещей, о которых я хотела бы знать до брака',
    text: "1. Секс не всегда будет на первом плане //n Как бы вы не//ни любили секс, " +
    "в долгосрочных отношениях его не всегда будет много. Настанут времена," +
    " когда ваш//ваши либидо не совпадут. Жаль, у меня нет гениального совета, " +
    "чтобы запрограмировать//запрограммировать кого-то хотеть больше или меньше секса." +
    " Но вот что я поняла: ваше желание здесь и сейчас не накладывает " +
    "автоматических обязательств на вашего партнёра, но потеря интимной" +
    " близости и охлаждение отношений — общая проблема. //n 2. Приятные мелочи " +
    "каждый день — универсальный рецепт //n Дело не только в цветах, чистом доме и " +
    "регулярном сексе (хотя и в этом то&nbsp;же).//тоже). Приятные мелочи — это" +
    " называть партнёра «любимый» или другим ласковым словом, от которого он всегда " +
    "млеет. Скажите: «Как приятно тебя слышать». Купите печенек — просто так," +
    " потому что ему или ей они нравятся. //n 3. Никогда не становитесь тем, кто " +
    "не готов работать над отношениями //n Вот вам жуткая правда: как бы один из " +
    "вас не//ни старался и не//ни лез из кожи вон, чтобы починить то, что в " +
    "отношениях сломанно,//сломано, сколько бы он не//ни ходил на психотерапию, " +
    "как бы не//ни хотел изменится,//измениться, неидеальный (а есть другие?) брак не " +
    "выживет, если второй будет сидеть сложа руки. "
  },
  {
    id: 9,
    possibleMistakeCount: 2,
    title: 'Я устал, я ухожу. Что такое саббатикал и зачем он нужен',
    text: "Год не ходить на работу. Заниматься тем, что нравиться://нравится: путешествовать, " +
    "строить дом, видеть, как растёт сын. А потом вернуться и взлететь вверх по карьерной " +
    "леснице.//лестнице. Звучит как мечта. Но это реальность. Это сабатикал.//саббатикал. //n Саббатикал " +
    "— это оплачиваемый или частично-оплачиваемый//частично&nbsp;оплачиваемый длительный" +
    " отпуск продолжительностью от трёх месяцев до года (и более) с гарантированым//гарантированным " +
    "сохранением места за сотрудником. Иными словами, это пауза в работе, " +
    "профессиональный тайм&nbsp;аут.//тайм-аут. //n В одних огранизациях//организациях для саббатикала " +
    "важен опыт работы, в других — нет. Некоторые кампании//компании готовы " +
    "растаться//расстаться с сотрудниками всего на 3–6 месяца,//месяцев," +
    " другие же отпускают их на несколько лет. Единственное неизменное условие" +
    " договора саббатикала — гарантия сохранения за сотрудником его должности."
  },
  {
    id: 10,
    possibleMistakeCount: 1,
    title: 'Центениалы: поколение, которое сотрёт нас с лица Земли',
    text: "Кто такие центениалы? //n Это люди, которые родились после 1996 или " +
    "после 2000 года (по данным различных исследований). Разброс в датах " +
    "появился, потому что исследований пока не&nbsp;много.//немного. " +
    "Центиниалы//центениалы ещё молоды, но их уже не//ни с кем не спутаешь. //n " +
    "Чем они отличаются от других поколений? //n Это первое поколение, которое родилось в эпоху " +
    "интернета. Центениалы не помнят, какой была жизнь без гаждетов,//гаджетов, и проводят " +
    "со смартфонами и планшетами больше 8 часов в день. На каждый шаг у них — " +
    "приложения, которыми они пользуються//пользуются также//так&nbsp;же естественно, " +
    "как дышат. Представители поколения Z не делят мир на цифровой и реальный, " +
    "их жизнь плавно перитекает//перетекает на экран и обратно. //n Что они умеют делать? //n Это" +
    " поколение, которое предпочитает увидеть. Общаясь в Сети, центениалы используют" +
    " эмодзи, смайлы, картинки. И они умеют зацепить аудиторию. Подростки точно знают," +
    " по каким законам живёт информацыя//информация и когда нужно публиковать снимок " +
    "в Instagramm,//Instagram, чтобы собрать больше лайков. Скажете, мелочи? А теперь " +
    "представьте, что будет, когда эти подростки с чутъём//чутьём на аудиторию выйдут " +
    "на рынок. Прошлые поколения в пролёте." 
  },
]



// WEBPACK FOOTER //
// ./src/data/index.js